import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import '../styles/Cart.css';

const Cart = () => {
  const { cart, removeFromCart, updateQuantity, getCartTotal } = useContext(CartContext);
  const navigate = useNavigate();
  const UPLOAD_URL = process.env.REACT_APP_UPLOAD_URL;

  // Normalize unit names
  const normalizeUnit = (unit) => {
    if (!unit) return unit;
    if (unit.toLowerCase() === 'gm') return 'gms';
    return unit;
  };

  if (cart.length === 0) {
    return (
      <div className="cart-empty">
        <h2>Your cart is empty</h2>
        <Link to="/products" className="btn-shop">Continue Shopping</Link>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <h1>Shopping Cart</h1>
      
      <div className="cart-container">
        <div className="cart-items">
          {cart.map(item => {
            const itemId = item._id || item.id;
            const itemName = item.productName || item.name;
            const itemImage = item.productImage || item.image;
            const imageUrl = itemImage?.startsWith('uploads') 
              ? `${UPLOAD_URL}/${itemImage.replace(/\\/g, '/')}` 
              : itemImage || '/item-image.png';
            
            return (
              <div key={itemId} className="cart-item">
                <img src={imageUrl} alt={itemName} />
                
                <div className="item-details">
                  <h3>{itemName}</h3>
                 
                </div>
                <div>
                 {item.selectedVariant && (
                    <p className="item-weight">{item.selectedVariant.weight}{normalizeUnit(item.selectedVariant.unit || 'kg')}</p>
                  )}
                  </div>
                
                <div className="quantity-controls">
                  <button onClick={() => updateQuantity(itemId, item.quantity - 1)}>-</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => updateQuantity(itemId, item.quantity + 1)}>+</button>
                </div>
                
                <div className="item-total">
                  <p>₹{(item.price * item.quantity).toFixed(2)}</p>
                </div>
                
                <button 
                  className="btn-remove"
                  onClick={() => removeFromCart(itemId)}
                >
                  Remove
                </button>
              </div>
            );
          })}
        </div>
        
        <div className="cart-summary">
          <h2>Order Summary</h2>
          <div className="summary-row">
            <span>Subtotal:</span>
            <span>₹{getCartTotal().toFixed(2)}</span>
          </div>
          <div className="summary-row">
            <span>Shipping:</span>
            <span>Free</span>
          </div>
          <div className="summary-row total">
            <span>Total:</span>
            <span>₹{getCartTotal().toFixed(2)}</span>
          </div>
          <button 
            className="btn-checkout"
            onClick={() => navigate('/checkout')}
          >
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cart;
